import axios from 'axios';
import qs from 'qs';
import router from '../router';
import store from '../store';

const API_PREFIX = process.env.VUE_APP_API_PREFIX;

function setHeaders(base, query, isFormdata = false) {
  const API_PREFIX = process.env.VUE_APP_API_PREFIX;
  const token = localStorage.getItem('session-nrm-spec');
  return {
    baseURL: base || API_PREFIX,
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
      'Content-Type': isFormdata ? 'multipart/form-data' : 'application/json',
    },
    params: query,
  };
}

async function requestWrapper(base, method, url, query, data, isFormdata = false) {
  switch (method) {
    case 'GET':
      return await axiosInstance.get(url, setHeaders(base, query));
    case 'POST':
      return await axiosInstance.post(url, data, setHeaders(base, query, isFormdata));
    case 'PUT':
      return await axiosInstance.put(url, data, setHeaders(base, query));
    case 'DELETE':
      return await axiosInstance.delete(url, setHeaders(base, query));
  }
}

const axiosInstance = axios.create({
  baseURL: `${API_PREFIX}`,
  paramsSerializer: function (params) {
    return qs.stringify(params, { arrayFormat: 'brackets' });
  },
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (!error.response) throw new Error('Ошибка соединения с сервером');

    if (error.response.status === 401) {
      localStorage.removeItem('session-nrm-spec');
      store.dispatch('setAuthError', error.response.data.error);
      router.push({
        name: 'Login',
        query: store.getters.currRedirectPage ? { redirect: store.getters.currRedirectPage } : '',
      });
    }
    if (error.response.status === 403) {
      router.push({ name: 'NotAccess' });
    }

    throw error;
  }
);

export { requestWrapper, axiosInstance };
